module.exports = __webpack_public_path__ + "sunsemweb/img/hr.b0533d1a.png";